<!-- Header con filtros y búsqueda -->
<app-table-header
  [showSearch]="showSearch"
  [showFilters]="showFilters"
  [showCreateButton]="showCreateButton"
  [filterOptions]="filterOptions"
  [filterLabels]="filterLabels"
  [createButtonText]="createButtonText"
  [createButtonIcon]="createButtonIcon"
  (searchChange)="searchControl.setValue($event)"
  (filterChange)="onFilterChange($event)"
  (clearFiltersClick)="handleClearFilters()"
  (createClick)="createClick.emit()"
>
  <ng-content></ng-content>
</app-table-header>

<!-- Cuerpo de la tabla -->
<app-table-body
  [columns]="visibleColumns()"
  [paginatedData]="paginatedData()"
  [allData]="filteredData()"
  [emptyRows]="emptyRows()"
  [showSorting]="showSorting"
  [icon1]="icon1"
  [icon2]="icon2"
  [icon3]="icon3"
  [icon1Tooltip]="icon1Tooltip"
  [icon2Tooltip]="icon2Tooltip"
  [icon3Tooltip]="icon3Tooltip"
  [showToggle]="showToggle"
  [sortColumn]="sortColumn"
  [sortDirection]="sortDirection"
  [filterOptions]="filterOptions"
  [filterOptionsLoading]="filterOptionsLoading"
  (iconAction1)="iconAction1.emit($event)"
  (iconAction2)="iconAction2.emit($event)"
  (iconAction3)="iconAction3.emit($event)"
  [icon1Validation]="icon1Validation"
  [icon2Validation]="icon2Validation"
  [icon3Validation]="icon3Validation"
  [showIcon1Conditionally]="showIcon1Conditionally"
  [icon1ConditionalField]="icon1ConditionalField"
  [icon1ConditionalValues]="icon1ConditionalValues"
  (toggleAction)="toggleAction.emit($event)"
  (sortChange)="onSort($event.column, $event.direction)"
  (dateFilterChange)="onDateFilter($event)"
  (multiSelectFilterChange)="onMultiSelectFilter($event)"
  (filterSearchChange)="onFilterSearch($event)"
  [resultsNotFoundText]="resultsNotFoundText"
  [isFirstColumnDark]="firstColumnDark"
  (rowClick)="rowClick.emit($event)"
  [enableRowClick]="enableRowClick"
  [chipStyleClasses]="chipStyleClasses"
></app-table-body>

<!-- Paginador -->
 @if (totalFilteredItems !== 0) {
<app-table-paginator
  [showPagination]="showPagination"
  [currentPage]="currentPage()"
  [pageSize]="pageSize()"
  [totalItems]="totalFilteredItems"
  (pageChange)="goToPage($event)"
  (pageSizeChange)="onPageSizeChange($event)"
  [itemType]="itemTypePaginationText"
  [itemFormatPaginationText]="itemFormatPaginationText"
></app-table-paginator>}
